import { render, staticRenderFns } from "./ed-class-builder-block.component.vue?vue&type=template&id=d2a12bca&scoped=true&"
import script from "./ed-class-builder-block.component.ts?vue&type=script&lang=ts&"
export * from "./ed-class-builder-block.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-class-builder-block.component.scss?vue&type=style&index=0&id=d2a12bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a12bca",
  null
  
)

export default component.exports